export default __webpack_public_path__ + "static/media/filter_close.0fc7fff4.svg";